import { loginRequest } from "../msalConfig";

export const callMsGraph = async msalInstance => {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
  }
  const response = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    scopes: [process.env.REACT_APP_SCOPES],
    account: account,
  });
  const headers = new Headers();
  const bearer = `Bearer ${response.accessToken}`;
  headers.append("Authorization", bearer);
  let graphData = null;
  try {
    // Add here the endpoints for MS Graph API services you would like to use.
    graphData = fetch("https://graph.microsoft.com/v1.0/me", {
      method: "GET",
      headers: headers,
      params: {
        $select:
          "id,mail,employeeLeaveDateTime,accountEnabled,employeeId,employeeType,employeeOrgData,onPremisesExtensionAttributes,givenName,surname,department,state,jobTitle,country,companyName,otherMails",
      },
    })
      .then(response => response.json())
      .catch(error => console.error("callMsGraph", error));
  } catch (error) {
    console.error(error);
  }
  return graphData;
};
